import { useEffect, useRef } from 'react'
import { QueueStatusEnum } from '../AppConstant'
import { resetElapsedSeconds, setElapsedSeconds } from '../redux/flows/portal/currentPatient'
import { store, useAppDispatch, useAppSelector } from '../redux/store'

/** Session counter interval — mounted on PortalLayout so it keeps running across tabs. */
export const useSessionTimer = () => {
  const dispatch = useAppDispatch()
  const sessionStatus = useAppSelector((state) => state.currentPatientPortal.sessionStatus)
  const currentVisitId = useAppSelector((state) => state.lobbyPortal.currentVisit?.visitId)

  const sessionStartRef = useRef<number | null>(null)
  const hasInitializedFromRedux = useRef(false)

  useEffect(() => {
    if (sessionStatus !== QueueStatusEnum.SERVICE_IN_PROGRESS) {
      sessionStartRef.current = null
      hasInitializedFromRedux.current = false
      if (store.getState().currentPatientPortal.elapsedSeconds !== 0) {
        dispatch(resetElapsedSeconds())
      }
      return
    }

    if (!sessionStartRef.current) {
      const elapsedSeconds = store.getState().currentPatientPortal.elapsedSeconds
      if (elapsedSeconds > 0 && !hasInitializedFromRedux.current) {
        sessionStartRef.current = Date.now() - elapsedSeconds * 1000
        hasInitializedFromRedux.current = true
      } else {
        sessionStartRef.current = Date.now()
      }
    }

    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - sessionStartRef.current!) / 1000)
      const next = elapsed >= 0 ? elapsed : 0
      if (store.getState().currentPatientPortal.elapsedSeconds !== next) {
        dispatch(setElapsedSeconds(next))
      }
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [sessionStatus, dispatch, currentVisitId])
}
